import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

const Title = ({ title, margin, fontSize, fontWeight, dataCy, gutterBottom }) => {
  return (
    <Typography variant="h1" gutterBottom={gutterBottom}>
      <Box fontWeight={fontWeight} fontSize={fontSize} data-cy={dataCy} lineHeight={1} my={margin}>
        {title}
      </Box>
    </Typography>
  );
};

Title.propTypes = {
  margin: PropTypes.number,
  dataCy: PropTypes.string,
  fontSize: PropTypes.number,
  gutterBottom: PropTypes.bool,
  title: PropTypes.string.isRequired,
  fontWeight: PropTypes.oneOf([
    'fontWeightLight',
    'fontWeightRegular',
    'fontWeightMedium',
    'fontWeightBold',
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
  ]),
};

Title.defaultProps = {
  margin: 1,
  fontSize: 24,
  dataCy: 'title',
  gutterBottom: false,
  fontWeight: 'fontWeightBold',
};

export default Title;
